<div class="page-wrapper chiller-theme toggled" [ngStyle]="commonservice.showTour">
  <main class="page-content">
    <div class="bgColor">
      <div class="container">
        <!-- Header -->
        <div class="row align-items-center" style="height: 4em;">
          <div class="col-md-6">
            <p class="appTitle mb-0">Trending News</p>
          </div>
          <div class="col-md-6 d-flex justify-content-end align-items-center">
            <p class="adminName mb-0 mr-2">{{ adminName }}</p>
            <img width="36px" height="36px" style="margin-left:0.5em;" src="assets/tenant-avatar.jpg" class="rounded-circle" />
          </div>
        </div>

        <!-- Search + Add on same line -->
        <div class="row my-4 align-items-center">
          <!-- Search wrapper -->
          <div class="col-md-5 col-lg-6">
            <div class="search-wrapper">
              <i class="fa fa-search search-icon" aria-hidden="true"></i>

              <input
                type="text"
                class="search-input"
                placeholder="Search materials, title, description..."
                [(ngModel)]="searchval"
                (input)="onChangeEvent($event)"
                aria-label="Search"
              />

              <button *ngIf="searchval" class="clear-btn" type="button" (click)="reset()" aria-label="Clear search">
                ✕
              </button>
            </div>
          </div>

          <!-- Add News button aligned right -->
          <div class="col-md-4 col-lg-3 ml-auto text-right">
            <button type="button" class="btn btn-primary addCourseBtn" (click)="openAdd()">
              <i class="fa fa-plus" aria-hidden="true"></i> Add News
            </button>
          </div>
        </div>

        <!-- Content -->
        <div *ngIf="showData">
          <div class="displayImages" *ngFor="let image of allCollegeImages; let indexOfelement = index;">
            <div class="row" style="margin-bottom: 0.7em; margin-top: 0.7em;">
              <div class="col-md-3">
                <h2>Title: {{ image.title }}</h2>
              </div>
              <div class="col-md-3" style="text-align:right;">
                <button type="button" class="btn btn-primary addCourseBtn" (click)="viewImages(indexOfelement)">View All</button>
              </div>
              <div class="col-md-3" style="text-align:right;">
                <button type="button" class="btn btn-primary addCourseBtn" (click)="openAdd1(indexOfelement)">Add Images</button>
              </div>
              <div class="col-md-3" style="text-align:right;">
                <button type="button" class="btn btn-primary addCourseBtn" (click)="deleteallImage(indexOfelement)">Delete All</button>
              </div>
            </div>

            <div class="row">
              <div class="col-md-3" *ngFor="let img of image.lessData" style="margin-bottom: 1em !important;">
                <div class="img-wraps">
                  <img class="clgImg" [src]="img.images" />
                  <i class="fa fa-trash-o closes" aria-hidden="true" (click)="deleteImage(img.image_id)"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="noData" *ngIf="showNodata">
          <h2>Currently No Data Available!</h2>
        </div>
      </div>

      <!-- Add News Modal -->
      <div class="backdrop" [ngStyle]="{'display':display}"></div>
      <div class="modal" id="successModel" tabindex="-1" role="dialog" [ngStyle]="{'display':display}">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header" *ngIf="showAdd">
              Add News
              <button type="button" class="close" aria-label="Close" (click)="onCloseHandled()">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div class="dltmodal-content animate modal-body dltBl">
              <form [formGroup]="courseForm">
                <label>Title</label>
                <input type="text" class="form-control" formControlName="titleval" [(ngModel)]="title" />

                <label>Description</label>
                <input type="text" class="form-control" formControlName="desval" [(ngModel)]="description" />

                <label class="uploadImage">Upload College Images
                  <i class="fa fa-camera iconCamera" aria-hidden="true"></i>
                  <input type="file" formControlName="colgImg" (change)="handleFileInput($event)" multiple />
                </label>

                <div class="addBtn" *ngIf="showAdd">
                  <button class="commonBtn mt-2" (click)="addtopnews()">Add News</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <!-- Images Modal -->
      <div class="backdrop" [ngStyle]="{'display':displayimages}"></div>
      <div class="modal" id="imagesModel" tabindex="-1" role="dialog" [ngStyle]="{'display':displayimages}">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header" *ngIf="showAdd">
              Add Syllabus
              <button type="button" class="close" aria-label="Close" (click)="onCloseHandled()">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="dltmodal-content animate modal-body dltBl">
              <form [formGroup]="collegeImagesForm">
                <label class="uploadImage">Upload Image
                  <i class="fa fa-camera iconCamera" aria-hidden="true"></i>
                  <input type="file" formControlName="colgImg" (change)="handleFileInput($event)" multiple />
                </label>

                <img class="multipleImg" width="80px" height="80px" *ngFor="let img of images" [src]="img" />

                <div class="addBtn" *ngIf="showAdd">
                  <button class="commonBtn mt-2" [disabled]="!collegeImagesForm.valid" (click)="addtrendingimageonly()">
                    Add Syllabus
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

    </div>
  </main>
</div>
